import { render, staticRenderFns } from "./CompaniesViewTabs.vue?vue&type=template&id=fed3ec30"
import script from "./CompaniesViewTabs.vue?vue&type=script&lang=js"
export * from "./CompaniesViewTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports